<template lang="pug">
v-form.d-flex.flex-column.flex-shrink-1.flex-grow-1( ref="courtForm" )
  app-card-title Карточка суда
  app-text-field( v-model="form.title" label="Наименование суда" :rules="[rules.required]" )
  app-text-field( v-model="form.alias" label="Алиас" :rules="[rules.required]" )
  app-select( v-model="form.type" label="Тип суда" :items="courtType" item-text="title" item-value="value" :rules="[rules.number]" )
</template>

<script>
import { $_validate_rules } from '@/common/ValidateRules'
import { CourtType } from '../models/ExpertCourt.model';

export default {
  name: "ExpertCourtForm",
  mixins: [$_validate_rules],
  props: {
    form: null,
  },

  computed: {
    courtType() {
      return Object.values(CourtType)
    }
  }
}
</script>